import React from 'react';

import { Icon } from '@soluto-design/react';
import Link, { LinkProps } from '@soluto-design/link';
import cls from '@soluto-design/styles/cls';

export interface BlockListItemProps extends LinkProps {}

const BlockListItem: React.FC<BlockListItemProps> = ({
    children,
    href,
    disabled,
    ...link
}) => {
    return (
        <>
            {!href ? (
                <span className="text-text-primary text-b300 py-sm block">
                    {children}
                </span>
            ) : (
                <Link
                    href={href}
                    className={cls(
                        'py-sm flex items-center justify-between w-full text-text-primary text-b300 !no-underline !font-regular hover:!text-text-brand-1 active:!text-text-secondary',
                        disabled &&
                            '!text-background-disabled hover:!text-background-disabled cursor-default',
                    )}
                    {...link}>
                    <span className="flex-1">{children}</span>
                    <Icon
                        icon="arrow-cricle--type-right-up"
                        className="text-[24px]"
                    />
                </Link>
            )}
        </>
    );
};

export default BlockListItem;
